// extracted by mini-css-extract-plugin
export default {"closeModalBtn":"SearchTipsModal_closeModalBtn__y4DEz","title":"SearchTipsModal_title__TRjZK","list":"SearchTipsModal_list__Hisdi"};